<form [formGroup]="form" (ngSubmit)="submitForm()">
  <h3 mat-dialog-title>{{ 'map.telestration.channelName' | t }}</h3>
  <mat-dialog-content>
    <p>{{ 'map.telestration.channelNameRequired' | t }}</p>  
    <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
  </mat-dialog-content>
  <mat-dialog-actions snButtonGroup>
    <button mat-button type="button" color="danger" (click)="close()">{{ 'common.cancel' | t }}</button>
    <button mat-button color="success" type="submit" [disabled]="form.invalid">{{ 'common.submit' | t }}</button>
  </mat-dialog-actions>
</form>
